module.exports = __webpack_public_path__ + "img/ccl_gallery10.8cc865b9.jpg";